"use client";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { Button, ButtonActions } from "@ui/components/button";
import { SectionTemplate } from "components/individuals/blocks";
import { Gcms_ButtonTheme } from "lib/cms-typings";
import { ButtonProp, ImageFragment } from "lib/gcms";
import { ThemeColor } from "lib/gcms/theme-color";
import Image from "next/image";

export interface DiveIntoServicesSectionProps {
  title: string;
  subtitle: string;
  button: ButtonProp;
  image: ImageFragment & { alt?: string };
  bg: ThemeColor;
  color: string;
}

export default function ClientDiveIntoServicesSection(
  props: DiveIntoServicesSectionProps,
) {
  return (
    <SectionTemplate bg={props.bg}>
      <Flex
        color={props.color}
        gap={14}
        justifyContent={{
          md: "space-between",
        }}
        flexDir={{
          base: "column",
          md: "row",
        }}
        alignItems={"center"}
      >
        <Flex
          flexDir={"column"}
          w={{
            md: "50%",
          }}
          align={{
            base: "center",
            md: "unset",
          }}
          justifyContent={{
            md: "space-between",
          }}
        >
          <Box
            textAlign={{
              base: "center",
              md: "left",
            }}
          >
            <Heading
              size="2xl"
              letterSpacing="tight"
              fontWeight="extrabold"
              lineHeight="normal"
            >
              {props.title}
            </Heading>
            <Text
              fontSize={{
                base: "md",
                lg: "lg",
              }}
              mt="10"
            >
              {props.subtitle}
            </Text>
          </Box>
          <Button
            __type={props.button?.buttonAction as ButtonActions}
            href={props.button?.href as string}
            colorScheme={props.button?.theme as Gcms_ButtonTheme}
            variant={props.button?.variant}
            label={props.button?.label}
            mt="14"
            py={{
              base: "6",
              lg: "8",
            }}
            px="5"
            w={{
              base: "140px",
              md: "160px",
              lg: "180px",
            }}
          />
        </Flex>
        <Box
          w={{
            md: "35%",
          }}
          maxW={{
            base: "350px",
            md: "450px",
          }}
          minW={{
            md: "350px",
            lg: "400px",
            xl: "450px",
          }}
        >
          <Image
            src={props.image.url}
            alt={props.image?.alt as string}
            height={props.image.height}
            width={props.image.width}
            placeholder={
              typeof props.image?.blurDataURL === "string" ? "blur" : undefined
            }
            blurDataURL={
              typeof props.image.blurDataURL === "string"
                ? props.image?.blurDataURL
                : undefined
            }
          />
        </Box>
      </Flex>
    </SectionTemplate>
  );
}
